export default "__VITE_ASSET__4GS5ngAD__"